import { useCallback } from "react"
import { graphql, useMutation, UseMutationConfig } from "react-relay"
import { useChDeletePrescriptionMutation as useChDeletePrescriptionMutationType } from "@/modules/patients/detail/prescription/ch/services/__generated__/useChDeletePrescriptionMutation.graphql"

const mutation = graphql`
  mutation useChDeletePrescriptionMutation($input: Ch_deletePrescriptionInput!) {
    ch_deletePrescription(input: $input) {
      ch_Prescription {
        id @deleteRecord
      }
    }
  }
`

const useChDeletePrescriptionMutation = () => {
  const [commit, isFlight] = useMutation<useChDeletePrescriptionMutationType>(mutation)

  const commitHandler = useCallback(
    (config: UseMutationConfig<useChDeletePrescriptionMutationType>) => {
      commit(config)
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useChDeletePrescriptionMutation }
